import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import axios from "axios";

export default function ManageSejarah() {
  const [deskripsi, setDeskripsi] = useState("");
  const [fotoList, setFotoList] = useState([]);
  const [fotoFile, setFotoFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const docRef = doc(db, "profilSekolah", "sejarah");

  // Ambil data awal
  const fetchSejarah = async () => {
    try {
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data();
        // pastikan foto berbentuk objek {url, judul, teks}
        const formattedFoto =
          Array.isArray(data.foto) &&
          data.foto.map((f) =>
            typeof f === "string" ? { url: f, judul: "", teks: "" } : f
          );

        setDeskripsi(data.deskripsi || "");
        setFotoList(formattedFoto || []);
      }
    } catch (err) {
      console.error("fetchSejarah error:", err);
    }
  };

  useEffect(() => {
    fetchSejarah();
  }, []);

  const handleFotoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setFotoFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const uploadToCloudinary = async (file) => {
    const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
    const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
    if (!CLOUD_NAME || !UPLOAD_PRESET)
      throw new Error("Cloudinary ENV belum diset.");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);

    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
      formData
    );
    return res.data.secure_url;
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      let newFotoList = [...fotoList];
      if (fotoFile) {
        Swal.fire({
          title: "Mengunggah...",
          text: "Tunggu sebentar, sedang upload ke Cloudinary...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });
        const uploadedUrl = await uploadToCloudinary(fotoFile);
        newFotoList.push({
          url: uploadedUrl,
          judul: `Momen Sejarah ${newFotoList.length + 1}`,
          teks: "",
        });
        Swal.close();
      }

      await setDoc(docRef, { deskripsi, foto: newFotoList });
      setFotoList(newFotoList);
      setFotoFile(null);
      setPreview(null);

      Swal.fire("Berhasil", "Data sejarah disimpan.", "success");
    } catch (err) {
      console.error("handleSave error:", err);
      Swal.fire("Error", "Gagal menyimpan: " + err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteFoto = async (index) => {
    const confirm = await Swal.fire({
      title: "Yakin hapus foto ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus",
      cancelButtonText: "Batal",
    });
    if (!confirm.isConfirmed) return;

    try {
      const updated = fotoList.filter((_, i) => i !== index);
      await setDoc(docRef, { deskripsi, foto: updated });
      setFotoList(updated);
      Swal.fire("Terhapus", "Foto dihapus dari daftar.", "success");
    } catch (err) {
      Swal.fire("Error", "Gagal menghapus foto: " + err.message, "error");
    }
  };

  const handleEditFotoText = (index, field, value) => {
    const updated = [...fotoList];
    updated[index] = { ...updated[index], [field]: value };
    setFotoList(updated);
  };

  const handleSaveFotoText = async () => {
    try {
      await setDoc(docRef, { deskripsi, foto: fotoList });
      Swal.fire("Berhasil", "Teks foto diperbarui.", "success");
    } catch (err) {
      Swal.fire("Error", "Gagal menyimpan teks foto: " + err.message, "error");
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="fw-bold mb-4">Kelola Halaman Sejarah Sekolah</h2>

      {/* Deskripsi */}
      <div className="mb-3">
        <label className="form-label fw-semibold">Deskripsi Utama</label>
        <textarea
          className="form-control"
          rows={4}
          value={deskripsi}
          onChange={(e) => setDeskripsi(e.target.value)}
        />
      </div>

      {/* Upload Foto */}
      <div className="mb-3">
        <label className="form-label fw-semibold">Tambah Foto Baru</label>
        <input
          type="file"
          className="form-control"
          onChange={handleFotoChange}
          disabled={loading}
        />
        {preview && (
          <img
            src={preview}
            alt="preview"
            style={{
              width: 220,
              height: 160,
              objectFit: "cover",
              marginTop: 8,
              borderRadius: 8,
            }}
          />
        )}
      </div>

      <button
        className="btn btn-primary mb-4"
        onClick={handleSave}
        disabled={loading}
      >
        {loading ? "Menyimpan..." : "Simpan Data"}
      </button>

      <hr />

      {/* Daftar Foto */}
      <h4 className="fw-semibold mt-4 mb-3">Daftar Foto Sejarah</h4>
      {fotoList.length === 0 ? (
        <p className="text-muted">Belum ada foto ditambahkan.</p>
      ) : (
        <div className="d-flex flex-wrap gap-4">
          {fotoList.map((foto, index) => (
            <div
              key={index}
              className="card shadow-sm"
              style={{ width: 260, borderRadius: 10 }}
            >
              <img
                src={foto.url}
                alt={`sejarah-${index}`}
                style={{
                  width: "100%",
                  height: 150,
                  objectFit: "cover",
                  borderTopLeftRadius: 10,
                  borderTopRightRadius: 10,
                }}
              />
              <div className="card-body">
                <input
                  type="text"
                  className="form-control mb-2"
                  placeholder={`Judul foto ${index + 1}`}
                  value={foto.judul || ""}
                  onChange={(e) =>
                    handleEditFotoText(index, "judul", e.target.value)
                  }
                />
                <textarea
                  className="form-control mb-2"
                  placeholder="Teks deskripsi foto"
                  rows={2}
                  value={foto.teks || ""}
                  onChange={(e) =>
                    handleEditFotoText(index, "teks", e.target.value)
                  }
                />
                <div className="d-flex justify-content-between">
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDeleteFoto(index)}
                  >
                    Hapus
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {fotoList.length > 0 && (
        <button className="btn btn-success mt-3" onClick={handleSaveFotoText}>
          Simpan Perubahan Teks
        </button>
      )}
    </div>
  );
}
